import axios from 'axios'
import { sessionToken } from '../utils/session'

function attachAuth(client) {
  client.interceptors.request.use((config) => {
    const token = sessionToken()
    if (token) config.headers.Authorization = `Bearer ${token}`
    return config
  })
  return client
}

export const accelApi = attachAuth(
  axios.create({
    baseURL: '/api/accel',
    timeout: 20000
  })
)

export const platformApi = attachAuth(
  axios.create({
    baseURL: '/api',
    timeout: 60000
  })
)
